<!-- 简介 -->
<template>
	<div class="intr-container">
		<div class="background"></div>
		<Header></Header>
		<div class="main">
			<el-row class="middle">
				<el-col class="middleRight">
					<el-row type="flex" justify="center">
						<el-col :xs="0" :sm="0" :md="0" :lg="2" :xl="2">
							<!-- <div style="background-color: red;height: 500px;width: 100%;"></div> -->
						</el-col>

						<el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
							<div class="intr-body">
								<div class="content" v-html="content"></div>
							</div>
						</el-col>
						<el-col :xs="0" :sm="0" :md="0" :lg="2" :xl="2"></el-col>
					</el-row>

				</el-col>
			</el-row>
		</div>

		
		<Footer></Footer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				content:null
			};
		},

		components: {},

		mounted() {
			this.getIntr()
		},

		methods: {
			getIntr()
			{
			  this.instance.get('/api/introduction/getintroduction',{

			  }).then(res=>{
			    if(res.status==200)
			    {
			      let data=res.data;
			      this.content=data.content;
			    }
			  })
			},
		},
    
	}
</script>
<style scoped>
	.intr-container::before {
		content: '';
		display: table;
	}

	.intr-main {
		width: 1600px;
		height: 100%;
		padding: 0 40px;
		overflow: hidden;
		color: #3C4A5D;
		margin: 45px auto;
		background-color: rgba(255, 255, 255, 0.85);
	}

	.intr-main>.title {
		margin-top: 20px;
	}

	.intr-main>hr {
		margin: 10px;
		border: 1px solid #D7D7D7;
	}

	.intr-main>.content {
		padding: 20px 20px;
	}

	.intr-main>.content>.imgArea {
		text-align: center;
	}

	.intr-main>.content>.imgArea>img {
		width: 800px;
		height: 450px;
	}

	.intr-main>.content>div>h3 {
		margin: 20px 0 10px 0;
	}

	.intr-main>.content>div>p {
		text-indent: 2rem;
	}


	/* 新布局 */
	.intr-body {
    padding: 2vw;
		position: relative;
		width: 100%;
		/* background-color: red; */
		background: hsla(0, 0%, 100%, .2);
		border: 0.1vw solid rgb(60, 74, 93, .2);
		/* border-radius: 0.9375rem; */
		box-shadow: 0 0.3vw 0.4vw rgba(0, 0, 0, .12), 0 0 0.6vw rgba(0, 0, 0, .04);
	}


	.intr-box {
		margin-left: 2vw;
		margin-right: 2vw;
	}

	.intr-img-box {
		text-align: center;
		margin-top: 2.5vw;
		margin-bottom: 2.5vw;
	}

	.intr-img {
		width: 100%;
	}

	.intr-title {
		font-size: 1.3vw;
		font-weight: bold;
		color: #3C4A5D;
		margin-top: 0.5vw;
		margin-bottom: 0.5vw;
	}

	.intr-second-title {
		font-size: 1vw;
		font-weight: bold;
		color: #3C4A5D;
		margin-bottom: 0.5vw;
	}

	.intr-second-info {
		font-size: 0.9vw;
		text-indent: 1.8vw;
	}

	.intr-second-info-last {
		margin-bottom: 2vw;
	}

	.intr-second-box {
		margin-bottom: 0.9vw;
	}




	@media screen and (max-width:1200px) {
		.intr-title {
			font-size: 2.3vw;
			margin-bottom: 1.1vw;
		}

		.intr-second-title {
			font-size: 1.8vw;
		}

		.intr-second-info {
			font-size: 1.4vw;
			text-indent: 2.8vw;
		}

		.intr-second-box {
			margin-bottom: 1.4vw;
		}
	}

	@media screen and (max-width:768px) {
		.intr-title {
			font-size: 3vw;
			margin-bottom: 1.5vw;
		}

		.intr-second-title {
			font-size: 2.4vw;
		}

		.intr-second-info {
			font-size: 2vw;
			text-indent: 4vw;
		}

		.intr-second-box {
			margin-bottom: 2vw;
		}
	}

	@media screen and (max-width:768px) {
		.intr-title {
			font-size: 5vw;
			margin-bottom: 2.5vw;
		}

		.intr-second-title {
			font-size: 4.5vw;
		}

		.intr-second-info {
			font-size: 4vw;
			text-indent: 8vw;
		}

		.intr-second-box {
			margin-bottom: 4vw;
		}

		.intr-second-info-last {
			margin-bottom: 6vw;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/Intr.vue